__turbopack_context__.v({
  "card": "kE8uUG_card",
  "cardBody": "kE8uUG_cardBody",
  "comingSoon": "kE8uUG_comingSoon" + " " + __turbopack_context__.i(168195)["smallButton"],
  "eyebrow": "kE8uUG_eyebrow" + " " + __turbopack_context__.i(168195)["eyebrow"],
  "grid": "kE8uUG_grid",
  "headingSubtitle": "kE8uUG_headingSubtitle" + " " + __turbopack_context__.i(168195)["subtitle"],
  "headingTitle": "kE8uUG_headingTitle" + " " + __turbopack_context__.i(168195)["title"],
  "headingWrap": "kE8uUG_headingWrap",
  "joinButton": "kE8uUG_joinButton" + " " + __turbopack_context__.i(168195)["smallButton"],
  "list": "kE8uUG_list",
  "rowText": "kE8uUG_rowText" + " " + __turbopack_context__.i(168195)["body"],
  "rowTitle": "kE8uUG_rowTitle" + " " + __turbopack_context__.i(168195)["listTitle"],
  "section": "kE8uUG_section",
  "textGroup": "kE8uUG_textGroup",
  "thumb": "kE8uUG_thumb",
  "thumbMuted": "kE8uUG_thumbMuted",
});
